// extracted by css-extract-rspack-plugin
export default {"boldText":"WomtxcBxuQS0Vu0I"};